import styled from 'styled-components';

export const TxtLink = styled.a.attrs(({ isNewTab }) => ({
  ...isNewTab && { target: '_blank' }
}))`
  line-height: ${({ lineheight }) => (lineheight ? lineheight : '14px')};
  font-size: ${({ size }) => (size ? size : '12px')};
  font-family: ${({ altFont }) => (altFont ? 'Roboto' : 'Noto Sans')};
  font-weight: ${({ weight }) => (weight ? weight : '400')};
  color: ${({ theme, color }) => (color ? color : theme.mocaGreen)} !important;
  cursor: ${({ showPointer }) => (showPointer ? 'pointer' : 'default')};

  &:hover {
    opacity: 0.7;
    color: ${({ theme, color }) => (color ? color : theme.mocaGreen)};
  }

  &:visited {
    color: ${({ theme, color }) => (color ? color : theme.mocaGreen)};
  }
`